__turbopack_context__.v({
  "container": "EnterHeaderDrawCountdown-module__UWq67W__container",
  "countdown": "EnterHeaderDrawCountdown-module__UWq67W__countdown",
  "separator": "EnterHeaderDrawCountdown-module__UWq67W__separator",
  "timeBlock": "EnterHeaderDrawCountdown-module__UWq67W__timeBlock",
  "variant__V2": "EnterHeaderDrawCountdown-module__UWq67W__variant__V2",
  "variant__V3": "EnterHeaderDrawCountdown-module__UWq67W__variant__V3",
});
